import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    listboxCotainer: {},
    listbox: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: px(0),
        maxWidth: px(256),
        maxHeight: px(256),
        border: [tokens.strokeWidthThin, 'solid', tokens.colorNeutralBackground6].join(' '),
        borderRadius: tokens.borderRadiusMedium,
        userSelect: 'none',
        overflowX: 'auto',
    },
    listboxOption: {
        marginBlock: `calc((${tokens.spacingVerticalXXS} * ${-1}))`,
        paddingBlock: `${tokens.spacingVerticalXXS} !important`,
        paddingInline: `${tokens.spacingVerticalS} !important`,
        minWidth: 'max-content',
        ':first-child': {
            marginTop: px(0),
        },
        ':last-child': {
            marginBottom: px(0),
        },
    },
    listboxButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: tokens.spacingVerticalXS,
    },
});
